import { DEFAULT_CURRENCY, formatMoney } from "@/profitability/currency";
import type { GoalCheckSummary } from "@/profitability/types";

export type FailedCheck = GoalCheckSummary["failed"][number];
export type MatchedCheck = NonNullable<GoalCheckSummary["matched"]>[number];

/** A value as the report shows it: a rate as a percentage, money with its cents. */
export const formatValue = (
  value: number | null,
  type: FailedCheck["type"],
  currency: string = DEFAULT_CURRENCY,
) => {
  if (value === null) return "none";
  if (type === "percent")
    return `${(value * 100).toLocaleString("en-US", { maximumFractionDigits: 2 })}%`;
  if (type === "currency") return formatMoney(value, currency, {});
  return value.toLocaleString("en-US", { maximumFractionDigits: 4 });
};

export const describe = (
  check: FailedCheck,
  currency: string = DEFAULT_CURRENCY,
) =>
  check.error
    ? `${check.label}: ${check.error}`
    : `${check.label}: the goal says ${formatValue(check.expected, check.type, currency)}, the report gives ${formatValue(check.actual, check.type, currency)}`;

export const describeMatch = (
  check: MatchedCheck,
  currency: string = DEFAULT_CURRENCY,
) => `${check.label}: ${formatValue(check.actual, check.type, currency)}`;
